"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationChannel = void 0;
const topic_1 = require("../../topic");
const NOTIFICATION_CHANNEL = 'notification';
class NotificationChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = NOTIFICATION_CHANNEL;
        this.topics = {
            ShowLoginNotification: new topic_1.Topic('ShowLoginNotification', NOTIFICATION_CHANNEL, this._logger),
        };
    }
}
exports.NotificationChannel = NotificationChannel;
//# sourceMappingURL=notification.channel.js.map